import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { productShortName } from '../data/offer';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-161" data-mp="21yd8ya0c84tx">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-xl border border-border bg-background p-4 pr-10 text-foreground shadow-lg" aria-live="polite" data-id="element-162" data-mp="1wyh3e6bzs5c9">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded-md p-1 text-muted transition-colors duration-150 ease-out hover:bg-surface-hover hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" aria-label="Dismiss notice" data-id="element-163" data-mp="1sg5yrt3pxp6k">
            <XIcon className="h-4 w-4" data-id="element-164" data-mp="1nga3ci93762m" />
          </button>
          <div className="flex gap-3" data-id="element-165" data-mp="1niwa4fo5lhjs">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden="true" data-id="element-166" data-mp="19owmjc2kcmba" />
            <div data-id="element-167" data-mp="1egn4a33tyccq">
              <p className="text-sm font-semibold text-foreground" data-id="element-168" data-mp="1eh6ip9u9uim0">Access confirmed</p>
              <p className="mt-1 text-sm leading-snug text-muted" data-id="element-169" data-mp="zs0d944ubw5o">
                Once your purchase is complete you receive the
                <br data-id="element-170" data-mp="14qv2anteigy8" />
                <span className="font-semibold text-foreground" data-id="element-171" data-mp="14nz6p65104cy">{productShortName}</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-172" data-mp="qswu605obgr6">Instant digital access by email.</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}